'use client'

import { type PropsWithChildren, createContext, useContext, useMemo, useState } from 'react'

type ActModeState = {
  /** Act mode: assistant-api runs routine writes without an approval card. Ask mode (false) proposes every write. */
  actMode: boolean
  setActMode: (actMode: boolean) => void
}

const ActModeContext = createContext<ActModeState>({ actMode: false, setActMode: () => undefined })

/**
 * Holds the Ask / Act choice above the panel, so it carries across conversations, new chats and organization
 * switches for as long as the page is open. A reload starts again in Ask mode.
 */
export function ActModeProvider({ children }: PropsWithChildren) {
  const [actMode, setActMode] = useState(false)
  const value = useMemo(() => ({ actMode, setActMode }), [actMode])
  return <ActModeContext.Provider value={value}>{children}</ActModeContext.Provider>
}

export function useActMode(): ActModeState {
  return useContext(ActModeContext)
}
